<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Master Data</p>
    </div>
    <section>
      <filtros-master-data-component
        @emitirFiltros="getFiltros"
      ></filtros-master-data-component>
    </section>
    <div class="row q-mt-lg justify-end">
      <q-btn
        label="Exportar"
        color="secondary"
        icon="file_upload"
        no-caps
        @click="exportar"
      />
    </div>
    <section class="q-mt-sm">
      <q-table
        flat
        title="Todos os Usuários do Sistema"
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        color="primary"
        :loading="disable"
        dense
        title-class="text-brand-5 text-weight-bold"
        :columns="columns"
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        hide-pagination
        @request="handleRequest"
      >
        <template #body-cell-centro="props">
          <q-td
            :style="
              props.row.users_deleted_at != null
                ? 'background-color: #e36664'
                : ''
            "
          >
            <span>{{ props.row.cost_center_epi_code }}</span>
            <span class="q-ml-sm q-mr-sm">-</span>
            <span>{{ props.row.cost_center_epi_name }}</span>
          </q-td>
        </template>
        <template #body-cell-centro2="props">
          <q-td
            :style="
              props.row.users_deleted_at != null
                ? 'background-color: #e36664'
                : ''
            "
          >
            <span>{{ props.row.cost_centers_code }}</span>
            <span class="q-ml-sm q-mr-sm">-</span>
            <span>{{ props.row.cost_centers_name }}</span>
          </q-td>
        </template>

        <template #body-cell-aprovador_centro_custo="props">
          <q-td
            :style="
              props.row.users_deleted_at != null
                ? 'background-color: #e36664'
                : ''
            "
          >
            <span v-if="props.row.aprovador_centro_custo == 0">NÃO</span>
            <span v-else>SIM</span>
          </q-td>
        </template>

        <template #body-cell-users_created_at="props">
          <q-td
            :style="
              props.row.users_deleted_at != null
                ? 'background-color: #e36664'
                : ''
            "
          >
            <span v-if="props.row.users_created_at">{{
              props.row.users_created_at
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
            <span v-if="props.row.users_created_at" class="q-ml-sm">{{
              props.row.users_created_at.split(" ")[1]
            }}</span>
          </q-td>
        </template>
        <template #body-cell-users_deleted_at="props">
          <q-td
            :style="
              props.row.users_deleted_at != null
                ? 'background-color: #e36664'
                : ''
            "
          >
            <span v-if="props.row.users_deleted_at">{{
              props.row.users_deleted_at
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
            <span v-if="props.row.users_deleted_at" class="q-ml-sm">{{
              props.row.users_deleted_at.split(" ")[1]
            }}</span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "users_id",
    label: "id",
    field: "users_id",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "users_name",
    label: "Nome",
    field: "users_name",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "users_sap",
    label: "SAP",
    field: "users_sap",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "roles_name",
    label: "Perfil",
    field: "roles_name",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "centro",
    label: "CC EPI",
    field: "centro2",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "centro2",
    label: "CC MATERIAL",
    field: "endereco",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "vendors_name",
    label: "UNIDADE",
    field: "vendors_name",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "aprovador_centro_custo",
    label: "Aprovador",
    field: "aprovador_centro_custo",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "users_created_at",
    label: "Criado em",
    field: "users_created_at",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
  {
    name: "users_deleted_at",
    label: "Excluido em",
    field: "users_deleted_at",
    align: "left",
    style: (row) =>
      row.users_deleted_at != null ? "background-color: #e36664" : "",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, computed, watch, onMounted } from "vue";

import { useRouter } from "vue-router";
import FiltrosMasterDataComponent from "../components/FiltrosMasterDataComponent.vue";
export default {
  components: { FiltrosMasterDataComponent },
  setup() {
    const store = useStore();
    const router = useRouter();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const filtrosSave = ref();
    const total = ref("");
    const unidadeDefault = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async (page = 0, rowsPerPage = 15, filtros) => {
      quasar.loading.show();

      try {
        let response = await store.dispatch("ind/getMasterData", {
          vendor_id:
            filtros && filtros.unidade
              ? filtros.unidade.id
              : unidadeDefault.value.id,

          cost_center: filtros && filtros.centro ? filtros.centro : undefined,
          cost_center_epi:
            filtros && filtros.centro ? filtros.centro : undefined,
          user: filtros && filtros.usuario ? filtros.usuario : undefined,
          page: page,
          perPage: rowsPerPage,
          status:
            filtros && filtros?.status === true ? undefined : filtros?.status,
          desligado: filtros && filtros?.status === true ? true : undefined,
        });

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;

        disable.value = false;
        quasar.loading.hide();
      } catch (error) {
        console.log(error);
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("ind/exportarMasterData", {
          vendor_id: unidadeDefault.value.id,
          cost_center:
            filtrosSave.value && filtrosSave.value.centro
              ? filtrosSave.value.centro
              : undefined,
          cost_center_epi:
            filtrosSave.value && filtrosSave.value.centro
              ? filtrosSave.value.centro
              : undefined,
          user:
            filtrosSave.value && filtrosSave.value.usuario
              ? filtrosSave.value.usuario
              : undefined,
          status:
            filtrosSave.value && filtrosSave.value?.status === true
              ? undefined
              : filtrosSave.value?.status,
          desligado:
            filtrosSave.value && filtrosSave.value.status === true
              ? true
              : undefined,
          page: pagination.value.page,
          perPage: pagination.value.rowsPerPage,
        });

        quasar.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidadeDefault.value = store.state.org.unidadeData;
      getDados();
    };
    onMounted(getUnidade);

    const handleRequest = async () => {
      getDados(
        pagination.value.page,
        pagination.value.rowsPerPage,
        filtrosSave.value
      );
    };

    const getFiltros = async (filtros) => {
      filtrosSave.value = filtros;
      getDados(1, pagination.value.rowsPerPage, filtrosSave.value);
    };

    const movimento = async (id) => {
      router.push({ name: "ind-estoque-movimento", params: { id: id } });
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidadeDefault.value = store.state.org.unidadeData;
      }
    );

    return {
      rows,
      columns,
      pagination,
      disable,
      getDados,
      handleRequest,
      exportar,
      total,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getFiltros,

      movimento,
      filtrosSave,
    };
  },
};
</script>

<style>
.q-table__top {
  padding: 12px 0px !important;
}
</style>
